module.exports = __webpack_public_path__ + "media/images/ecalls/03_reasons_position_size-1f88ca7bfbc466fbfb1b8a60216ac139.png";